export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12324.5d477430.jpg";